import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FooterLink } from 'containers/Auth/Auth.styles'
import { Arrowback } from '@dsny/dsny-component-library/icons'
import { Banner } from '@dsny/dsny-component-library'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import {
  Title,
  Content,
  ContentLink,
  Row,
  SuccessContainer,
  GoBackOption,
  ContentWrapper
} from './SuccessPage.styles'
import { FullWidthButton } from '../AuthForm.styles'

export default function SuccessPage({
  children,
  onSubmit,
  title,
  dataCy,
  returnSignInAction,
  showForgotLayout,
  forgotPasswordLayout,
  isExpiredLink,
  isRequestResent,
  isMagicLinkResent,
  resetLayout
}) {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMobileMediaQuery()

  const returnAction = () => {
    returnSignInAction()
  }

  return (
    <SuccessContainer data-cy={dataCy} $isMobile={isMobile}>
      {isRequestResent && (
        <Banner
          variant="info"
          mode="dark"
          style={{ marginBottom: 32, maxWidth: '100%' }}
          bannerContent={{
            title: t('login.password-reset-resent'),
            description: t('login.resent-password-content')
          }}
        />
      )}

      {isMagicLinkResent && (
        <Banner
          variant="info"
          mode="dark"
          style={{ marginBottom: 32, maxWidth: '100%' }}
          bannerContent={{
            title: t('login.magic-link-resent'),
            description: t('login.magic-link-resent-content')
          }}
        />
      )}

      {forgotPasswordLayout && (
        <GoBackOption onClick={showForgotLayout}>
          <Arrowback
            width={16}
            color={theme.colors.neutralW100}
            style={{ marginRight: 4 }}
          />
          <p>{t('login.go-back')}</p>
        </GoBackOption>
      )}

      {isExpiredLink && (
        <Banner
          variant="error"
          mode="dark"
          style={{ marginBottom: 32, maxWidth: '100%' }}
          bannerContent={{
            title: t('error.expired-link'),
            description: t('error.password-reset-link-has-expired')
          }}
        />
      )}

      <Title>{title}</Title>

      {children}

      {isExpiredLink && (
        <FullWidthButton
          style={{ marginTop: '24px' }}
          color="primary"
          setting="player"
          onClick={onSubmit}
        >
          {t('login.email-me-a-new-link')}
        </FullWidthButton>
      )}
      {!resetLayout && (
        <Row>
          <Content>{t('login.didnt-receive-an-email')}</Content>
          <ContentLink onClick={onSubmit}>
            {t('login.resend-email')}
          </ContentLink>
        </Row>
      )}

      <FooterLink style={{ textAlign: 'center' }} onClick={returnAction}>
        <ContentWrapper>
          {t('login.return-to')}
          {` `}
          <span style={{ fontWeight: 700, color: theme.colors.interact70 }}>
            {t('login.sign-in')}
          </span>
          {t('login.page')}
        </ContentWrapper>
      </FooterLink>
    </SuccessContainer>
  )
}

SuccessPage.propTypes = {
  dataCy: PropTypes.string,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  title: PropTypes.string
}
